import React, { useEffect, useState } from "react";
import { useGetEquipmentQuery, useGetSitesQuery } from "store/abcoApi";
import { Link, Text, H1, Box, HStack, Button } from "components/ui";
import Pagination from "components/navigation/Pagination";
import Head from "expo-router/head";
import ScrollContainer from "components/general/ScrollContainer";
import Container from "components/general/Container";
import { ActivityIndicator, TouchableOpacity } from "react-native";
import EquipmentTable from "components/equipment/EquipmentTable";
import { useIsMobile } from "utils/hooks/useIsMobile";
import EquipmentHeader from "components/equipment/EquipmentHeader";
import PageLoader from "components/general/PageLoader";
import AbcoMap from "components/map";
import { ListTree, Map, TriangleAlert, TriangleAlertIcon } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";
import DismissableContent from "components/general/DismissableContent";
export default function Page() {
	const isMobile = useIsMobile();
	const [groupIdCollection, setGroupIdCollection] = React.useState<number[]>([]);
	const [equipmentTypeIdCollection, setEquipmentTypeIdCollection] = React.useState<number[]>([]);
	const [isHire, setIsHire] = React.useState<boolean | undefined>(undefined);
	const [isMapView, setIsMapView] = React.useState(false);
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const resolvedWarningMain = useToken("colors", "warningmain");
	const { data, isLoading, isFetching, isError, error, currentData } = useGetEquipmentQuery({
		pageSize: 9999,
		groupIdCollection: groupIdCollection,
		equipmentTypeIdCollection,
		isHire,
	});

	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;

	// Only reset page when data actually changes
	useEffect(() => {
		if (data?.list) {
			setCurrentPage(1);
		}
	}, [data?.list]);

	console.log(groupIdCollection);

	const totalItems = data?.list?.length || 0;
	const totalPages = Math.ceil(totalItems / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const paginatedData = data?.list?.slice(startIndex, endIndex) || [];

	if (isFetching && isLoading) {
		return (
			<Box minHeight={"$full"} justifyContent="center" borderRadius={16}>
				<ActivityIndicator size={"large"} style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }, { translateY: 25 }] }} />
			</Box>
		);
	}
	// let filteredMapData = data?.list?.filter(item => item?.latitude && item?.longitude);

	return (
		<ScrollContainer>
			<Container>
				<EquipmentHeader onSiteChange={setGroupIdCollection} onEquipmentTypeChange={setEquipmentTypeIdCollection} onIsHireChange={setIsHire} />

				{isMapView && data?.list && (
					<Box marginTop={30} paddingHorizontal={48}>
						<AbcoMap data={data && data?.list.filter((item: any) => item?.latitude && item?.longitude)} />
					</Box>
				)}
				<Box marginTop={30} paddingHorizontal={48}>
					<HStack marginBottom={30} gap={8} justifyContent="flex-end">
						{!isMapView && (
							<Button
								gap={8}
								alignItems="center"
								onPress={() => {
									setIsMapView(true);
								}}
							>
								<Map size={24} color={resolvedPrimarylight} />
								<Box borderBottomColor="$primarylight" borderBottomWidth={1}>
									<Text color="$primarylight">View as map</Text>
								</Box>
							</Button>
						)}
						{isMapView && (
							<Button
								gap={8}
								alignItems="center"
								onPress={() => {
									setIsMapView(false);
								}}
							>
								<ListTree size={24} color={resolvedPrimarylight} />
								<Box borderBottomColor="$primarylight" borderBottomWidth={1}>
									<Text color="$primarylight">View as list</Text>
								</Box>
							</Button>
						)}
					</HStack>
				</Box>
				<Box>
					<Box zIndex={8} paddingHorizontal={isMobile ? 16 : 47} paddingVertical={isMobile ? 12 : 27} bg="$neutral25" borderRadius={16}>
						{isFetching && <ActivityIndicator size="large" style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }, { translateY: 25 }] }} />}
						{data != null && <EquipmentTable dataList={paginatedData} />}
						{totalPages > 0 && (
							<Box justifyContent="center" alignItems="center" paddingVertical={16}>
								<Pagination pageCount={totalPages} pageNumber={currentPage} onChangePage={(newPage) => setCurrentPage(newPage)} />
							</Box>
						)}
					</Box>
				</Box>
			</Container>
		</ScrollContainer>
	);
}
